// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui';
import './permission'; // 权限
import store from './store';
import './styles/common.scss';
import axios from 'axios'
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

// import * as Quill from 'quill'; //引入编辑器
// import { Quill } from 'vue-quill-editor';
// import resizeImage from 'quill-image-resize-module'; // 图片缩放组件。
// Quill.register('modules/resizeImage ', resizeImage);


import Pagination from "@/components/Pagination";

import yxGbCpn from '@/components/global';
Vue.use(yxGbCpn);// 注册全局组件

Vue.use(VueQuillEditor);
Vue.prototype.$axios = axios //将axios绑定到vue的原型上
//  引入Echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(Element);
Vue.component('Pagination', Pagination)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js